import UserTypes from './types'

export function logout() {
    return { type: UserTypes.USER_LOGOUT }
}

export const update = (newUser) => ({
    type: UserTypes.USER_UPDATE,
    payload: newUser,
});
